import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=161b03a6&scoped=true&"
import script from "./TheHeading.vue?vue&type=script&lang=js&"
export * from "./TheHeading.vue?vue&type=script&lang=js&"
import style0 from "./TheHeading.vue?vue&type=style&index=0&id=161b03a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b03a6",
  null
  
)

export default component.exports